import { PASSWORD_MIN_LENGTH, PASSWORD_REQUIREMENT_HINT, SetPasswordParams } from "@pentacode/core";
import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { alert } from "../../../elements/alert-dialog";
import { Dialog } from "../../../elements/dialog";
import { app } from "../../../init";
import { validateNewPasswordInputs } from "../../../lib/password-input";

@customElement("ptc-change-password-dialog")
export class ChangePasswordDialog extends Dialog<void, void> {
    @query("input[name='newPassword']")
    private _newPasswordInput: HTMLInputElement;

    @query("input[name='repeatPassword']")
    private _repeatPasswordInput: HTMLInputElement;

    @query("form")
    private _form: HTMLFormElement;

    async show() {
        [...this.renderRoot.querySelectorAll("#changePasswordForm input")].forEach(
            (el: HTMLInputElement) => (el.value = "")
        );
        return super.show();
    }

    private _checkPasswordInputs() {
        validateNewPasswordInputs(this._newPasswordInput, this._repeatPasswordInput, {
            email: app.account?.email,
            firstName: app.account?.firstName,
            lastName: app.account?.lastName,
            companyName: app.company?.name,
        });
    }

    private async _submit(e: FocusEvent) {
        e.preventDefault();

        if (this.loading) {
            return;
        }

        this.loading = true;

        const formData = new FormData(this._form);
        const oldPassword = formData.get("oldPassword") as string;
        const password = formData.get("newPassword") as string;

        try {
            await app.api.setPassword(
                new SetPasswordParams({
                    id: app.account!.id,
                    password,
                    oldPassword,
                })
            );
            await app.fetchAccount();
            this.done();
            void alert("Passwort erfolgreich geändert!", { type: "success" });
        } catch (e) {
            this.hide();
            await alert(e.message, { type: "warning" });
            this._show();
        }
        this.loading = false;
    }

    renderContent() {
        return html`
            <div class="semibold double-padded border-bottom">
                <ptc-ui-icon name="icon.action.set-password"></ptc-ui-icon> Passwort Ändern
            </div>
            <form class="padded" id="changePasswordForm" @input=${this._checkPasswordInputs} @submit=${this._submit}>
                <div class="field">
                    <label>Altes Passwort</label>
                    <input type="password" name="oldPassword" required />
                </div>

                <div class="field">
                    <label>Neues Passwort</label>
                    <input type="password" name="newPassword" required minlength=${PASSWORD_MIN_LENGTH} />
                    <div class="small subtle">${PASSWORD_REQUIREMENT_HINT}</div>
                </div>

                <div class="field">
                    <label>Passwort Wiederholen</label>
                    <input type="password" name="repeatPassword" required />
                </div>

                <div class="top-padded horizontal spacing evenly stretching layout">
                    <button class="primary">Passwort Ändern</button>
                    <button class="transparent" type="button" @click=${() => this.done()}>Abbrechen</button>
                </div>
            </form>
        `;
    }
}
